<div class="recovery-page">
  <main class="recovery-card">
    <div class="brand">
      <div class="brand-icon">
        <mat-icon>local_hospital</mat-icon>
      </div>
      <span>Expediente Avicena</span>
    </div>

    @if (exito) {
      <div class="success-icon">
        <mat-icon>check_circle</mat-icon>
      </div>

      <h1>¡Contraseña actualizada!</h1>

      <p class="description">
        Tu contraseña se cambió correctamente. Ya puedes iniciar sesión con tus nuevas credenciales.
      </p>

      <button mat-flat-button type="button" class="primary-button" (click)="volverLogin()">
        Ir al inicio de sesión
      </button>
    } @else {
      <div class="illustration">
        <mat-icon>lock_reset</mat-icon>
      </div>

      <h1>Restablecer contraseña</h1>

      <p class="description">Crea una nueva contraseña para recuperar el acceso a tu cuenta.</p>

      @if (!token) {
        <div class="error-message" role="alert">
          <mat-icon>error_outline</mat-icon>
          <span>{{ error }}</span>
        </div>

        <button
          mat-flat-button
          type="button"
          class="primary-button"
          (click)="solicitarOtroEnlace()"
        >
          Solicitar nuevo enlace
        </button>
      } @else {
        <form [formGroup]="form" (ngSubmit)="guardarPassword()">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Nueva contraseña</mat-label>

            <mat-icon matPrefix>lock_outline</mat-icon>

            <input
              matInput
              [type]="mostrarPassword ? 'text' : 'password'"
              formControlName="password"
              autocomplete="new-password"
              maxlength="128"
            />

            <button
              mat-icon-button
              matSuffix
              type="button"
              (click)="mostrarPassword = !mostrarPassword"
              [attr.aria-label]="mostrarPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
            >
              <mat-icon>
                {{ mostrarPassword ? 'visibility_off' : 'visibility' }}
              </mat-icon>
            </button>

            @if (form.controls.password.hasError('required') && form.controls.password.touched) {
              <mat-error>La contraseña es obligatoria.</mat-error>
            }

            @if (form.controls.password.hasError('minlength')) {
              <mat-error> Debe contener al menos 12 caracteres. </mat-error>
            }

            @if (form.controls.password.hasError('maxlength')) {
              <mat-error> No puede superar los 128 caracteres. </mat-error>
            }
          </mat-form-field>

          <p class="password-hint">
            Utiliza al menos 12 caracteres y una contraseña difícil de adivinar. Puedes usar una
            frase larga.
          </p>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Confirmar contraseña</mat-label>

            <mat-icon matPrefix>lock_outline</mat-icon>

            <input
              matInput
              [type]="mostrarConfirmacion ? 'text' : 'password'"
              formControlName="confirmarPassword"
              autocomplete="new-password"
              maxlength="128"
            />

            <button
              mat-icon-button
              matSuffix
              type="button"
              (click)="mostrarConfirmacion = !mostrarConfirmacion"
              [attr.aria-label]="
                mostrarConfirmacion ? 'Ocultar confirmación' : 'Mostrar confirmación'
              "
            >
              <mat-icon>
                {{ mostrarConfirmacion ? 'visibility_off' : 'visibility' }}
              </mat-icon>
            </button>

            @if (
              form.controls.confirmarPassword.hasError('required') &&
              form.controls.confirmarPassword.touched
            ) {
              <mat-error>Confirma tu nueva contraseña.</mat-error>
            }

            @if (
              form.hasError('contrasenasDiferentes') && form.controls.confirmarPassword.touched
            ) {
              <mat-error>Las contraseñas no coinciden.</mat-error>
            }
          </mat-form-field>

          @if (error) {
            <div class="error-message" role="alert">
              <mat-icon>error_outline</mat-icon>
              <span>{{ error }}</span>
            </div>
          }

          <button
            mat-flat-button
            type="submit"
            class="primary-button"
          >
            @if (cargando) {
              <!-- <mat-icon class="loading-icon"  >sync</mat-icon> -->
              Guardando...
            } @else {
              Guardar nueva contraseña
            }
          </button>
        </form>

        <button mat-button type="button" class="back-button" (click)="volverLogin()">
          <mat-icon>arrow_back</mat-icon>
          Volver al inicio de sesión
        </button>
      }
    }

    <p class="footer-text">Expediente Avicena · Gestión de atención médica</p>
  </main>
</div>
